export enum IntegrationCategory {
        CRM = 0,
        Notifications = 1,
        Donations = 2,
        Connectors = 3,
        Analytics = 4
}
